import { Component, OnInit } from '@angular/core';
import {AutoCadService} from "../../services/CADService/auto-cad.service";
import {CadMarker} from "../../models/CadMarker";
import {EsBsModalService} from "../../services/bsModalService/bs-modal.service";
import {CesiumAdapterService} from "../../services/cesiumAdapter21/cesium-adapter.service";

@Component({
  selector: 'app-cad-auto-confirm',
  templateUrl: './cad-auto-confirm.component.html',
  styleUrls: ['./cad-auto-confirm.component.scss']
})
export class CadAutoConfirmComponent implements OnInit {

  public currentMarkers:CadMarker[];
  public Yiit = Yiit;

  constructor(private cad: AutoCadService, private bsModal: EsBsModalService, private cesiumAdapter: CesiumAdapterService) { }

  ngOnInit() {
    // this.cad.markersPlaced.subscribe((markers)=>{
    //   this.currentMarkers = markers;
    //   this.bsModal.openModal({modalId: '#cad-confirm-modal'});
    // })
  }


  syncMarkers(){
    // this.cad.synchronizeMarkers();
  }

  cancelSync(){
    // this.cad.clearMarkers();
  }

}
